
import React                         from 'react';
import { Observe }                   from 'rewire-core';
import Button                        from '@material-ui/core/Button';
import Icon                          from '@material-ui/core/Icon';
import { Theme, makeStyles }         from '../utility/styles';
import { ToolbarButtons }            from './RuleSettingsEditor';
import TimeOffAccrualRuleEditorModel from './TimeOffAccrualRuleEditorModel';

const styles = (theme: Theme) => ({
  runRulesButton: {
    color: theme.palette.warning.contrastText,
    backgroundColor: theme.palette.warning.main,
  }
});

const useToolbarStyles = makeStyles(styles);

export const ToolbarRunRulesButton = ({settings}: {settings: TimeOffAccrualRuleEditorModel}) => {
  const styles = useToolbarStyles();
  return (
    <Observe>{() => (
      <Button className={'span1 ' + styles.runRulesButton} variant='contained' disabled={!settings.canRunAccrualRules()} onClick={() => settings.runAccrualRules()} title='Run Accrual Rules'>
        <Icon className='undo'>{'autorenew'}</Icon>
      </Button>
  )}</Observe>
  );
};

export default ({settings}: {settings: TimeOffAccrualRuleEditorModel}) => {
  return (
    <ToolbarButtons settings={settings}>
      <ToolbarRunRulesButton settings={settings} />
    </ToolbarButtons>
  );
};
